import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Button } from "react-bootstrap";
import { masterActions, productActions } from "../../../_store";

import PageTitle from "../../layouts/PageTitle";
import General from "./GeneralTab";
import Inventory from "./InventoryTab";
import Attributes from "./AttributesTab";

const CreateProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

   // Extract ProductID from location state
  const editProductID = location.state ? location.state.ProductID : 0;
    // Access the active product tab from Redux state
  const ActiveProductTab = useSelector((x) => x.product.activeProductTab);


  useEffect(() => {
    // Clear product data if no product ID is present
    if (editProductID === 0) {
      dispatch(productActions.clearProductData());
    }

    // Define a common status value
    const status = 1;

    // Fetch dropdown lists
    dispatch(masterActions.GetWarehouseList({ WareHouseID: 0, Status: status }));
    dispatch(masterActions.GetCategoryDrpList({ CategoryID: 0, Status: status }));
    dispatch(masterActions.GetSubCategoryDrpList({ CategoryID: 0, SubCategoryID: 0, Status: status }));
    dispatch(masterActions.GetvendorDrpList({ VendorID: 0, Status: status }));
    dispatch(masterActions.GetstockStatusDrpList({ StockStatusID: 0, Status: status }));
    dispatch(masterActions.GetAttributeDrpList({ AttributeID: 0, Status: status }));
    dispatch(masterActions.GetshippingMethodDrpList({ ShippingMethodID: 0, Status: status }));
    dispatch(masterActions.GetTermDrpList({ AttributeID: 0, TermID: 0, Status: status }));
    dispatch(masterActions.GetPackageTypeDrpList({ PackageTypeID: 0, Status: status }));

    // Fetch product details if valid product ID
    if (editProductID > 0) {
      dispatch(productActions.GetProductDetailsByID({ ProductID: editProductID }));
    }
  }, [dispatch]);

  const TabClick = (tab) => {
    dispatch(productActions.tempActiveProductTab(tab));
  };

  const handlechanges = () => {
    navigate("/productlist");
  };

  return (
    <>
      <PageTitle
        activeMenu={editProductID > 0 ? "Edit Product" : "Create Product"}
        motherMenu="Products"
        pageContent="Tab"
      />
      <ToastContainer />
      <div className="col-xl-12">
        <div className="card">
          <div>
            <div className="product-float-sm-end">
              <Button variant="btn btn-danger" onClick={handlechanges}>
                Back
              </Button>
            </div>
          </div>
          <div className="card-body">
            <div className="profile-tab">
              <div className="custom-tab-1">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <div
                      data-toggle="tab"
                      onClick={() => TabClick("General")}
                      className={`nav-link ProductTab ${
                        ActiveProductTab === "General" ? "active show" : ""
                      }`}
                    >
                      General
                    </div>
                  </li>
                  <li className="nav-item">
                    <div
                      data-toggle="tab"
                      onClick={() => TabClick("Inventory")}
                      className={`nav-link ProductTab ${
                        ActiveProductTab === "Inventory" ? "active show" : ""
                      }`}
                    >
                      Inventory
                    </div>
                  </li>
                  <li className="nav-item">
                    <div
                      data-toggle="tab"
                      onClick={() => TabClick("Attributes")}
                      className={`nav-link ProductTab ${
                        ActiveProductTab === "Attributes" ? "active show" : ""
                      }`}
                    >
                      Attributes
                    </div>
                  </li>
                </ul>
              </div>
              <div className="tab-content">
                <div
                  id="General"
                  className={`tab-pane fade ${
                    ActiveProductTab === "General" ? "active show" : ""
                  }`}
                >
                  <General
                  // EditProductID={editProductID}
                  />
                </div>
                <div
                  id="Inventory"
                  className={`tab-pane fade ${
                    ActiveProductTab === "Inventory" ? "active show" : ""
                  }`}
                >
                  <Inventory />
                </div>
                <div
                  id="Attributes"
                  className={`tab-pane fade ${
                    ActiveProductTab === "Attributes" ? "active show" : ""
                  }`}
                >
                  <Attributes />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateProduct;
